export const getSimpleDate = (date) => {
    return new Date(date).toLocaleDateString();
}

export const getFullDate = (date) => {
    return new Date(date).toLocaleString();
}